import React from 'react';
import { isBrowser } from 'react-device-detect';
import { checkInstalledApp, localization } from './utils'
import logo from './images/lintasin_driver.png';
import './App.css';

function App() {

  if(isBrowser) {
    window.location.href = 'https://lintasin.app';
  } else {
    checkInstalledApp();
  }

  const lang = localization();

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>{lang.text1}</p>
        <p><b>{lang.or}</b></p>
        <p>{lang.text2}</p>
      </header>
    </div>
  );
}

export default App;
